module.exports = "<div class=myselect-wrapper><div class=btn-wrapper v-on=\"click: showChoices = !showChoices\"><div class=chosen-text><span class=\"glyphicon glyphicon-triangle-bottom\" aria-hidden=true></span> <small>{{displayText}}</small></div></div><div v-if=showChoices class=choice-wrapper><div class=desc-wrapper><small style=color:#888888>{{desc}}</small></div><div class=option-wrapper v-repeat=\"option in options\" v-on=\"click: onChoose($event,option)\"><small>{{option.text}}</small></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/controls/custom-select.vue
// module id = 84
// module chunks = 0